
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Aortic_aneurysm',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/Aortic_aneurysm.vue